
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-tiktok-video-generator",
      function () {
        return require("private-next-pages/ai-tiktok-video-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-tiktok-video-generator"])
      });
    }
  